import React from "react";
import LockIcon from "../../../../svgs/shopping-bag.svg";
import UserIcon from "../../../../svgs/card.svg";
import BuildingIcon from "../../../../svgs/building.svg";
import DocumentIcon from "../../../../svgs/document-upload.svg";
import TypeIcon from "../../../../svgs/type.svg";

import "./POContent.scss";
import DocumentUpload from "../../../Common/DocumentUpload";
import { getInventoryTypeTitle } from "../../../../../../utilities/helpers";
import FormField from "../../../../../Shared/Form/FormField";

const PODetailsModal = ({ onClose, poData }) => {
  return (
    <div className="inventory-modal-overlay" onClick={onClose}>
      <form
        className="po-create-modal inventory-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ pointerEvents: "auto" }}
      >
        <div className="inventory-modal-header">
          <h3>PO Details</h3>
          <button className="close-btn" type="button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="inventory-modal-body">
          <div className="inventory-modal-body-content">
            <div className="po-info-section">
              <h2>PO Information</h2>
              <DocumentUpload
                attachment={poData.attachment}
                handleAttachmentChange={() => {}}
                uploadTitle="Upload PO Attachment"
                downloadTitle={
                  poData.attachment ? "Download PO Attachment" : "No Attachment"
                }
                downloadMode={true}
                documentIcon={DocumentIcon}
              />
              <div className="inventory-form-container">
                <FormField
                  id="po-number"
                  name="poNumber"
                  title="PO Number"
                  type="text"
                  icon={LockIcon}
                  value={poData.poNumber}
                  readOnly
                />
                <FormField
                  id="po-initiator"
                  name="poInitiator"
                  title="PO Initiator"
                  type="text"
                  icon={UserIcon}
                  value={poData.poInitiator}
                  readOnly
                />
                <FormField
                  id="inventory-type"
                  name="inventoryType"
                  title="Inventory Type"
                  icon={TypeIcon}
                  type="text"
                  value={getInventoryTypeTitle(poData.inventoryType)}
                  readOnly
                />
                <FormField
                  id="po-description"
                  name="poDescription"
                  title="PO Description"
                  type="textarea"
                  value={poData.description}
                  readOnly
                />
              </div>
            </div>
            <div className="supplier-device-section">
              <h2>Supplier Information</h2>
              <div className="inventory-form-container po-supplier-form">
                <FormField
                  id="supplier"
                  name="supplier"
                  title="Supplier"
                  type="text"
                  icon={BuildingIcon}
                  value={poData.supplier}
                  readOnly
                />
              </div>
              <h2>Device Information</h2>
              <div className="device-box">
                <div className="total-cost">
                  Total Cost &nbsp;
                  <span>
                    BDT&nbsp;
                    {poData.devices
                      .reduce(
                        (sum, d) =>
                          sum +
                          parseInt(d.totalCost?.replace(/,/g, "") || "0", 10),
                        0
                      )
                      .toLocaleString()}
                    .00
                  </span>
                </div>
                <div className="device-header">
                  <div className="device-field">Item</div>
                  <div className="device-field">Quantity</div>
                  <div className="device-field">Unit Cost (BDT)</div>
                  <div className="device-field">Total Cost (BDT)</div>
                  <div className="device-field"></div>
                </div>
                <div className="device-rows">
                  {poData.devices.map((device, idx) => (
                    <div className="device-row" key={idx}>
                      <div className="device-field">
                        <input
                          type="text"
                          value={device.itemName || device.item}
                          className="form-input select-input"
                          readOnly
                        />
                      </div>
                      <div className="device-field">
                        <input
                          type="number"
                          value={device.quantity}
                          className="form-input"
                          readOnly
                        />
                      </div>
                      <div className="device-field">
                        <input
                          type="number"
                          value={device.unitCost}
                          className="form-input"
                          readOnly
                        />
                      </div>
                      <div className="device-field">
                        <input
                          type="text"
                          value={device.totalCost}
                          className="form-input"
                          readOnly
                        />
                      </div>
                      <div className="device-field device-remove"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="inventory-modal-footer">
          <button className="submit-btn" type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </form>
    </div>
  );
};

export default PODetailsModal;
